"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Check_1 = require("./../Check");
var TreeNode = /** @class */ (function (_super) {
    __extends(TreeNode, _super);
    function TreeNode(props) {
        var _this = _super.call(this, props) || this;
        _this.treeNodeRef = react_1.default.createRef();
        return _this;
    }
    TreeNode.prototype.render = function () {
        var _this = this;
        /**
         * 展示个数
         * @default 9
         */
        var showLenCount = 9;
        var _a = this.props, root = _a.root, _b = _a.currentIndex, currentIndex = _b === void 0 ? 0 : _b, _c = _a.showText, showText = _c === void 0 ? 'Show All' : _c, _d = _a.showLessText, showLessText = _d === void 0 ? 'Show Less' : _d, _e = _a.data, _f = _e.childRoot, childRoot = _f === void 0 ? false : _f, name = _e.name, disabled = _e.disabled, children = _e.children, indeterminate = _e.indeterminate, _g = _e.collapsed, collapsed = _g === void 0 ? false : _g, _h = _e.checked, checked = _h === void 0 ? false : _h, key = _e.key;
        var caret;
        if (children) {
            if (children.length > 0) {
                caret = (react_1.default.createElement("span", { className: "collapse ".concat(collapsed ? 'caret-right' : 'caret-down'), onClick: function () { return _this.props.onCollapse(key); } }));
            }
        }
        // 设置子节点class状态
        var variable = root || childRoot;
        // 限定展示节点个数
        var switchHandle = function (event) {
            if (!event)
                return true;
            var targetElement = event.target;
            var getParentNodes = targetElement.parentNode || { childNodes: [] };
            var getChildNodes = getParentNodes.childNodes;
            Array.from(getChildNodes).forEach(function (item) {
                var newItemList = item;
                if (newItemList.className.indexOf('hidden') > -1) {
                    if (window.getComputedStyle(newItemList).display === 'block') {
                        newItemList.style.display = 'none';
                        targetElement.innerText = showText;
                    }
                    else {
                        newItemList.style.display = 'block';
                        targetElement.innerText = showLessText;
                    }
                }
            });
        };
        var hiddenClass = currentIndex > showLenCount ? 'hidden' : '';
        return (react_1.default.createElement("div", { className: "tree-node ".concat(!variable ? 'm-top-12' : 'm-top-27', " ").concat(hiddenClass, " "), draggable: true, ref: this.treeNodeRef },
            !root ? (react_1.default.createElement("div", { className: (0, classnames_1.default)('inner', {
                    'mb-inner--bgColor': variable,
                }) },
                react_1.default.createElement("span", { className: "content" },
                    react_1.default.createElement(Check_1.CheckComponent, { checked: checked, name: name, indeterminate: indeterminate, disabled: disabled, onCheck: function () { var _a, _b; return (_b = (_a = _this.props).onCheck) === null || _b === void 0 ? void 0 : _b.call(_a, key); } }),
                    react_1.default.createElement("span", { className: "content-spacer" },
                        caret,
                        react_1.default.createElement("span", { className: (0, classnames_1.default)("".concat(variable ? 'txt' : 'txt-child'), {
                                disabled: disabled,
                            }) }, name))))) : null,
            children && children.length > 0 && !collapsed && (react_1.default.createElement("div", { className: (0, classnames_1.default)({
                    'children-node': !root,
                    'children-node--offset': childRoot,
                }) },
                children.map(function (item, index) { return (react_1.default.createElement(TreeNode, { currentIndex: index || 0, onCheck: _this.props.onCheck, onCollapse: _this.props.onCollapse, setFromNode: _this.props.setFromNode, onMove: _this.props.onMove, key: item.key, data: item, showText: showText, showLessText: showLessText })); }),
                Number(children.length) > showLenCount + 1 ? (react_1.default.createElement("div", { className: "switch", onClick: switchHandle }, showText)) : null))));
    };
    return TreeNode;
}(react_1.default.Component));
exports.default = TreeNode;
//# sourceMappingURL=TreeNode.js.map